import { alpha, Box, Chip, useMediaQuery } from "@mui/material";
import { QuickFilterType } from "../../services/enum";
import { Prono } from "../../services/type";
import { FC } from "react";
import ListIcon from '@mui/icons-material/List';
import BoltIcon from '@mui/icons-material/Bolt';
import ShieldIcon from '@mui/icons-material/Shield';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { isBase, isCrack, isOutsider } from "../../../../utils/prono";

const QuickFilterButtons: FC<{
    activeFilter: QuickFilterType;
    onFilterChange: (filter: QuickFilterType) => void;
    pronos: Array<Prono>;
}> = ({ activeFilter, onFilterChange, pronos }) => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const counts: Record<QuickFilterType, number> = {
        [QuickFilterType.ALL]: pronos.length,
        [QuickFilterType.CRACK]: pronos.filter(isCrack).length,
        [QuickFilterType.BASE]: pronos.filter(isBase).length,
        [QuickFilterType.OUTSIDER]: pronos.filter(isOutsider).length,
    };

    const filters: Array<{
        key: QuickFilterType;
        label: string;
        icon: React.ElementType;
        color: string;
    }> = [
            { key: QuickFilterType.ALL, label: 'Tous', icon: ListIcon, color: '#616161' },
            { key: QuickFilterType.CRACK, label: 'Cracks', icon: BoltIcon, color: '#D4AF37' },
            { key: QuickFilterType.BASE, label: 'Bases', icon: ShieldIcon, color: '#2B4FA8' },
            { key: QuickFilterType.OUTSIDER, label: 'Outsiders', icon: TrendingUpIcon, color: '#2D8D98' },
        ];

    return (
        <Box display="flex" flexDirection="row" gap={1} flexWrap="wrap">
            {filters.map(({ key, label, icon: Icon, color }) => {
                const isActive = activeFilter === key;
                const count = counts[key];
                const isDisabled = key !== QuickFilterType.ALL && count === 0;

                return (
                    <Chip
                        key={key}
                        icon={
                            <Icon
                                color={isActive ? 'white' : isDisabled ? 'text.disabled' : color}
                                sx={{
                                    fontSize: isMobile ? 16 : 18,
                                }}
                            />
                        }
                        label={`${label} (${count})`}
                        onClick={() => onFilterChange(key)}
                        disabled={isDisabled}
                        sx={(theme) => ({
                            fontWeight: 600,
                            fontSize: isMobile ? 12 : 13,
                            bgcolor: isActive ? theme.palette.secondary.main : 'transparent',
                            color: isActive ? 'white' : isDisabled ? theme.palette.text.disabled : color,
                            border: '1.5px solid',
                            borderColor: isActive
                                ? theme.palette.secondary.main
                                : isDisabled
                                    ? theme.palette.action.disabledBackground
                                    : color,
                            opacity: isDisabled ? 0.5 : 1,
                            '&:hover': {
                                bgcolor: isActive ? theme.palette.secondary.main : alpha(color, 0.1),
                            },
                            '&.Mui-disabled': {
                                opacity: 0.5,
                                borderColor: theme.palette.action.disabledBackground,
                                color: theme.palette.text.disabled,
                            },
                            transition: 'all 0.15s ease',
                        })}
                    />
                );
            })}
        </Box>
    );
};

export default QuickFilterButtons